import React, { createContext, useContext, useState, useCallback } from 'react';

interface SidebarCollapseContextType {
  isCollapsed: boolean;
  toggleCollapse: () => void;
}

const STORAGE_KEY = 'sidebar_collapsed';

const SidebarCollapseContext = createContext<SidebarCollapseContextType | undefined>(undefined);

export const SidebarCollapseProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch {
      return false;
    }
  });

  const toggleCollapse = useCallback(() => {
    setIsCollapsed(prev => {
      const next = !prev;
      try { localStorage.setItem(STORAGE_KEY, String(next)); } catch {}
      return next;
    });
  }, []);

  return (
    <SidebarCollapseContext.Provider value={{ isCollapsed, toggleCollapse }}>
      {children}
    </SidebarCollapseContext.Provider>
  );
};

export const useSidebarCollapse = () => {
  const context = useContext(SidebarCollapseContext);
  if (!context) {
    throw new Error('useSidebarCollapse must be used within SidebarCollapseProvider');
  }
  return context;
};
